import { Injectable } from '@angular/core';
import {BackendService} from './backend.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {HttpClient} from "@angular/common/http";
import {OptionResponseDto} from "../dto/option.reponse.dto";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  private urlPrefix = '/api/option/list';

  constructor(private backend: BackendService) {}

  getCatalogList(catalogCode: string): Observable<any> {
    const url = `${this.urlPrefix}/${catalogCode}`;
    return this.backend.get(url).pipe(
        map((response: ResponseDto) => response.response)
    );
  }
  getCatalogOptionList(catalogCode: string, optionCode: string): Observable<any> {
    const url = `${this.urlPrefix}/${catalogCode}/option/${optionCode}`;
    return this.backend.get(url).pipe(
        map((response: ResponseDto) => response.response)
    );
  }
}
